import { Input, InputProps, Typography } from "antd";

interface Props extends InputProps {
    label: string
    placeholder: string
    width?: string
    error?: string
    prefix?: React.ReactNode
}

const InputBox = ({ label, placeholder, width = "100%", error, prefix, ...rest }: Props) => {
    return (
        <div style={{ width: width }}>
            <Typography.Text style={{ 
                display: 'block',
                color: "#475569", 
                fontWeight: 500, 
                fontSize: "12px", 
                lineHeight: "1.5", 
                marginBottom: "6px",
                fontFamily: "inherit" 
            }}>
                {label}
            </Typography.Text>
            <Input 
                size="large" 
                prefix={prefix}
                style={{ 
                    borderRadius: "12px", 
                    width: "100%",
                    height: "44px",
                    borderColor: "#e2e8f0",
                    fontSize: "13px",
                    color: "#1e293b"
                }} 
                placeholder={placeholder} 
                {...rest} 
            />
            {error && (
                <Typography.Text type="danger" style={{ fontSize: '11px', marginTop: '4px', display: 'block' }}>
                    {error}
                </Typography.Text>
            )}
        </div>
    )
}

export default InputBox;